import Vue from 'vue'
import SelfSelect from './self-select';
import SelfOption from './self-option';
Vue.component('SelfSelect', SelfSelect);
Vue.component('SelfOption', SelfOption);
